<script setup lang="ts">
// The assistant's "working on it" tile: a slowly turning gradient ring around
// a breathing sparkle, in the same colours as the assistant launcher so a
// running job is recognisably the assistant's doing. It is decorative — the
// text next to it carries the actual status — so it stays hidden from
// assistive technology.
import HugeIcon from '../HugeIcon/HugeIcon.vue';

const SPARKLE_ICON_SIZE_PX = 20;
</script>

<template>
  <div
    class="from-secondary-50 to-primary-50 relative flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-gradient-to-br"
    aria-hidden="true"
    data-testid="ai-working-indicator"
  >
    <span class="ai-working-indicator__ring absolute h-8 w-8 rounded-full" />
    <HugeIcon
      icon="sparkle"
      :size="SPARKLE_ICON_SIZE_PX"
      class="ai-working-indicator__sparkle text-primary-500 relative"
    />
  </div>
</template>

<style scoped>
/* A conic gradient masked down to a thin ring, so only the ring turns. */
.ai-working-indicator__ring::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: conic-gradient(
    from 0deg,
    var(--color-secondary-500),
    var(--color-primary-500),
    var(--color-secondary-500)
  );
  mask: radial-gradient(
    farthest-side,
    transparent calc(100% - 0.1875rem),
    #000 0
  );
  animation: ai-working-indicator-turn 2400ms linear infinite;
}

.ai-working-indicator__sparkle {
  animation: ai-working-indicator-breathe 1800ms ease-in-out infinite;
}

@keyframes ai-working-indicator-turn {
  to {
    transform: rotate(360deg);
  }
}

@keyframes ai-working-indicator-breathe {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.15);
  }
}

@media (prefers-reduced-motion: reduce) {
  .ai-working-indicator__ring::before,
  .ai-working-indicator__sparkle {
    animation: none;
  }
}
</style>
